import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem("pos_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("pos_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  useEffect(() => {
    const lock = () => setUser((u) => (u ? { ...u, license_expired: true } : u));
    window.addEventListener("license-expired", lock);
    return () => window.removeEventListener("license-expired", lock);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("pos_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("pos_token");
    localStorage.removeItem("pos_station_activated");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, reload: loadUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
